// import logo from './logo.svg';
import './App.css';
import { BrowserRouter } from 'react-router-dom';
import Router from './router/index';

/**
  * 获取设备信息
 */
export const getDeviceType = (pcBaseUrl, andBaseUrl,ipBaseUrl) => {
  const ua = navigator.userAgent;
  const ipad = ua.match(/(iPad).*OS\s([\d_]+)/),
    isIphone = !ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/),
    isAndroid = ua.match(/(Android)\s+([\d.]+)/),
    // isWechat = /micromessenger/i.test(ua),
    isMobile = isIphone || isAndroid;
  if (!isMobile) {
    window.location.href = pcBaseUrl
  }
   else if (isIphone) {
     window.location.href = ipBaseUrl
   } 
  else if (isAndroid) {
    window.location.href = andBaseUrl
  }
}

/**
  * 获取设备信息
 */
 export const getDeviceType2 = (pcBaseUrl, andBaseUrl,macBaseUrl,ipBaseUrl) => {
  const ua = navigator.userAgent;
  const ipad = ua.match(/(iPad).*OS\s([\d_]+)/),
    isIphone = !ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/),
    isAndroid = ua.match(/(Android)\s+([\d.]+)/),
    // isWechat = /micromessenger/i.test(ua),
    isMobile = isIphone || isAndroid;
  if(ua.indexOf('Mac OS') != -1 && !isIphone){ //mac端打开
    window.location.href = macBaseUrl
    return;
  }
  else if (!isMobile) {
    window.location.href = pcBaseUrl
  }
   else if (isIphone) {
     window.location.href = ipBaseUrl
   }
  else if (isAndroid) {
    window.location.href = andBaseUrl
  }
}

/**
  * 获取移动端设备信息
 */
export const getMobileType = (andBaseUrl,iosBaseUrl) => {
  const ua = navigator.userAgent;
  const ipad = ua.match(/(iPad).*OS\s([\d_]+)/),
    isIphone = !ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/),
    isAndroid = ua.match(/(Android)\s+([\d.]+)/);
    // isWechat = /micromessenger/i.test(ua),
    // isMobile = isIphone || isAndroid;
  if (isIphone) {
    window.location.href = iosBaseUrl
  } else if (isAndroid) {
    window.location.href = andBaseUrl
  }
}

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Router />
      </div>
    </BrowserRouter>
  );
}

export default App;
